import { mapState, mapActions } from 'vuex';
import router from '@/services/router.js';

export default  {	
	data () {
		return { 
			users: { email: '', password: ''},
		}
	},
	created()
	{		
		this.logout()	
	},
	computed: { 
	  ...mapState({
		  logged                  : state => state.authStore.logged, 
		  errornotification       : state => state.authStore.errornotification, 
	  })   
	},
	methods: {
	  ...mapActions({    
		  logout:     'authStore/logout',  
		  errorNot:     'authStore/errorNot',  
	  })
	}
}
